import type {
  OwnTransportIngredientResponse,
  OwnTransportIngredientAdapter,
} from '@libs/trip-planner-interfaces';

import { assertSmartSearchValue } from '../../utils';

import type { IngredientResponseQL } from './itineraryResponseQL';

export type OwnTransportIngredientResponseQL = Extract<
  IngredientResponseQL,
  { type: 'OwnTransportQL' }
>;
export function toOwnTransportIngredientResponse(
  result: OwnTransportIngredientResponseQL,
  ingredient: OwnTransportIngredientAdapter
): OwnTransportIngredientResponse {
  assertSmartSearchValue(result.date);
  return {
    date: new Date(result.date),
    ingredientType: ingredient.ingredientType,
    ingredientId: ingredient.ingredientId,
    isAvailable: true,
    ownTransportType: ingredient.ownTransportType,
  };
}
